module.exports = __webpack_public_path__ + "img/vdleftarw.83225114.svg";